import React from 'react';
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Container,
  Row,
} from 'reactstrap';
import PageNavigation from './PageNavigation';
import MobileUserMenu from './MobileUserMenu';
import domainModel from 'domain-model';
import IconX from 'flaivy-react/components/icons/IconX';

const { isPrivabShop } = domainModel.shopConfig;

const MobileOffCanvas = ({ isOpen, toggle, asPath, shopConfig }) => {
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      className="navbar-version-2 navbar-version-1 navbar-mobile-offcanvas d-lg-none"
      direction="end"
    >
      <OffcanvasHeader className="d-flex justify-content-end text-light">
        <Button onClick={toggle} color="none">
          <IconX
            stroke={isPrivabShop(shopConfig) ? 'white' : 'black'}
            height="25"
          />
        </Button>
      </OffcanvasHeader>

      <OffcanvasBody className="pt-0">
        <Container>
          <PageNavigation
            toggleHamburgerMenu={toggle}
            isHamburgerMenuOpen={isOpen}
            asPath={asPath}
          />
          <hr className="my-1" />
          <Row>
            <MobileUserMenu />
          </Row>
        </Container>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default MobileOffCanvas;
